export default __webpack_public_path__ + "../staticImages/account-newsletter-subscribe.png";